const API_KEY = 'pk.b84a0cac621dcdbddf9e872d30410b67';

function limitDecimals(n: number): number {
  return parseFloat(n.toFixed(7));
}

export function resolveAddressToCoordinates(
  onSuccess: (latitude: number, longitude: number) => void,
  street: string,
  street2: string,
  state: string,
  city: string,
  country: string,
  postalCode: string
) {
  const queryString = `${country}, ${street}, ${street2}, ${postalCode}, ${city}, ${state}`;

  fetch(
    `https://us1.locationiq.com/v1/search?key=${API_KEY}&q=${encodeURIComponent(
      queryString
    )}&format=json`
  )
    .then(r => r.json())
    .then((r: any) => {
      if (r.length === 0) {
        return;
      }
      const result = r[0];
      const { lat, lon } = result;

      onSuccess(limitDecimals(Number(lat)), limitDecimals(Number(lon)));
    })
    .catch(err => console.log(err));
}

export const getTimezoneFromCity = async (
  {
    city,
    countryName,
  }: {
    city: string;
    countryName: string;
  },
  onSuccess: (field: string, value: any) => void
) => {
  try {
    const res = await fetch(
      `https://dev.virtualearth.net/REST/v1/TimeZone/query=${city},${countryName}?key=${API_KEY}`
    );
    const dataObject = await res.json();
    const timeZoneData =
      dataObject.resourceSets[0].resources[0].timeZoneAtLocation[0];
    onSuccess('timeZone', timeZoneData.timeZone[0].ianaTimeZoneId);
  } catch (err) {
    console.log(err);
  }
};
